import React, { Component } from 'react'
import { connect } from 'react-fela'
import ds from 'views/styles/designSystem'
import { pxTo } from 'design-system-utils'
import PropTypes from 'prop-types'

class AvatarUser extends Component {
  static propTypes = {
    styles: PropTypes.object.isRequired,
    firstname: PropTypes.string.isRequired,
    lastname: PropTypes.string.isRequired,
  }

  render() {
    const { styles } = this.props

    return <div className={styles.initials} />
  }
}

const rules = {
  initials: (props) => ({
    width: pxTo(40, ds.get('type.baseFontSize'), 'rem'),
    height: pxTo(40, ds.get('type.baseFontSize'), 'rem'),
    backgroundColor: ds.get('colors.white'),
    borderRadius: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ':after': {
      content: `"${props.firstname.substr(0, 1)}${props.lastname.substr(0, 1)}"`,
      textTransform: 'uppercase',
      display: 'block',
      color: ds.get('colors.blueNight'),
      zIndex: 5,
      fontSize: ds.get('type.baseFontSize'),
    },
  }),
}

export default connect(rules)(AvatarUser)
